import { render, staticRenderFns } from "./studyList.vue?vue&type=template&id=108f545f"
import script from "./studyList.vue?vue&type=script&lang=js"
export * from "./studyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports